module.exports = __webpack_public_path__ + "assets/img/phone1.6d09ca5b.png";